module.exports = __webpack_public_path__ + "img/avatar3.d3c49b72.png";